module.exports = __webpack_public_path__ + "static/media/29COICT10.6f1a9e8e.jpg";